<template>
  <span class="holder">
    <span class="text">
      <slot>ayyy</slot>
    </span>
    <span class="skeleton rounded" :class="bgClass">
      
      <div class="shimmer" :style="shimmerStyle">
      </div>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    bgClass: { type: String, default: 'bg-light' },
    shineColor: { type: String, default: '#FFF' }
  },
  computed: {
    shimmerStyle () {
      return 'background-image: linear-gradient(90deg, rgba(255,255,255,0) 0px, ' + this.shineColor + ' 20px, rgba(255,255,255,0) 40px);'
    }
  }
}
</script>

<style scoped>
.holder {
  position: relative;
}
.text {
  visibility: hidden;
}
.skeleton {
  background-color: #F7F8F9;
  overflow: hidden;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.shimmer {
  background-size: 40px 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 40px;
  animation: shine-lines 2s infinite ease-in-out;
}

@keyframes shine-lines {
  0% {
    left: -80px;
  }
  100% {
    left: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TextSkeleton.vue